import React from 'react';
import './Home.css';

import heroImage from '../Assets/Images/header photo.png';
import toneGif from '../Assets/Animations/website-tone-animation.gif';
import libraryGif from '../Assets/Animations/website-library-example-with-blind-reviewa-nimation-still.gif';
import teamsGif from '../Assets/Animations/website-blind-review.gif';
import {Link} from "react-router-dom";


const HomePage: React.FC = () => {
    return (
        <div className="home-page">
            <section className="intro-section">
                <div className="intro-text">
                    <h2>Upskill your communication.</h2>
                    <h2>Build real belonging.</h2>
                    <p>
                        Get instant guidance as you type to help you communicate more inclusively.
                    </p>
                    <div className="button-row">
                        <span>Get started today and transform the way your team connects.</span>
                    </div>
                </div>
                <div className="intro-image">
                    <img src={heroImage} alt="Team Communication" className="track-gif"/>
                </div>
            </section>


            <section className="animation-section">
                <h2>What makes VIZEdi great</h2>
                <div className="content-container">
                    <div className="text-container">
                        <h1 className="animation-title">Get on-the-spot help with your word choices</h1>
                        <p className="animation-text">VIZEdi gives instant suggestions as you type so you can choose the right words as you go.</p>
                    </div>
                    <div className="image-container">
                        <img src={teamsGif} alt="Real-time suggestions GIF" className="suggestion-gif"/>
                    </div>
                </div>

                <div className="content-container">
                    <div className="text-container">
                        <h1 className="animation-title">Access instant help from the VIZEdi Library, with quick term look ups</h1>
                        <p className="animation-text">Look up terms whenever you need to, right within your workflow.</p>
                    </div>
                    <div className="image-container">
                        <img src={libraryGif} alt="Teams" className="track-gif"/>
                    </div>
                </div>

                <div className="content-container">
                    <div className="text-container">
                        <h1 className="animation-title">Adjust your tone for better connection and receptivity</h1>
                        <p className="animation-text">Get immediate insights and refine your tone for better communication</p>
                    </div>
                    <div className="image-container">
                        <img src={toneGif} alt="Personal insights GIF" className="leadership-gif"/>
                    </div>
                </div>
            </section>

            <section className="why-it-matters">
                <h2>Why It Matters</h2>
                <p>Fostering belonging at work requires mindful communication. The VIZEdi Desktop App ensures that your
                    messages are always respectful and inclusive, helping to create a
                    workplace where everyone feels like they belong. Inclusive language isn't just about avoiding
                    offense; it's about fostering trust, collaboration, and engagement across your team.</p>
            </section>


            <section className="subscription-section">
                <h2>Subscription Plans</h2>
                <div className="subscription-plans">
                    <div className="subscription-plan trial">
                        <h3>Free Trial</h3>
                        <p className="price">7-Day Full Access</p>
                        <ul className="features">
                            <li><span className="checkmark"></span>Try Everything VIZEdi has to offer</li>
                            <li><span className="checkmark"></span>Real Time Term Checking</li>
                            <li><span className="checkmark"></span>Tone Analysis</li>
                        </ul>
                    </div>

                    <div className="subscription-plan monthly">
                        <h3>Monthly Subscription</h3>
                        <p className="price">$20<span>USD</span>/month</p>
                        <ul className="features">
                        <li><span className="checkmark"></span>Real Time Term Checking</li>
                            <li><span className="checkmark"></span>Tone Analysis</li>
                            <li><span className="checkmark"></span>Cancel Anytime</li>
                        </ul>
                    </div>

                    <div className="subscription-plan annually">
                        <h3>Annual Subscription</h3>
                        <p className="price">$96<span>USD</span>/year</p>
                        <ul className="features">
                            <li><span className="checkmark"></span>Real Time Term Checking</li>
                            <li><span className="checkmark"></span>Tone Analysis</li>
                            <li><span className="checkmark"></span>Cancel Anytime</li>
                        </ul>
                    </div>
                </div>
            </section>

            <section>
                <div className="cta-section">
                    <h2 className="cta-title">Get Started</h2>
                    <p className="cta-description">
                        Download the VIZEdi desktop app today
                    </p>
                    <Link to="/login">
                        <button className="cta-button">Download</button>
                    </Link></div>
            </section>
        </div>
    );
};

export default HomePage;